import * as React from "react";

import { PageLoadSpinner } from "../shared/components/PageLoadSpinner";
import { Utilities } from "../shared/utilities";
import { getEnvironmentsAndPromotedVariables, getRules, getTimeZones } from "./actions/AppActions";
import { initialState, reducer } from "./reducers/AppReducer";
import { IAppReducerState } from "./shared/model";
import { ThemeProvider } from "styled-components";
import useUserTheme from "shared/styles/hooks/useUserTheme";
import { useParams } from "react-router-dom";
import Layout from "./components/Layout";

export const AppContext = React.createContext<IAppReducerState>({ state: initialState, dispatch: () => null });

const App: React.FC<React.PropsWithChildren<unknown>> = () => {
    const [themeType] = useUserTheme();
    const [state, dispatch] = React.useReducer(reducer, initialState);
    const { environmentName } = useParams<{ environmentName: string }>();

    React.useEffect(() => {
        getEnvironmentsAndPromotedVariables(dispatch);
        const getUserPermissions = () => {
            const permissions = Utilities.getAllUserPermissions();
            dispatch({ type: "SET_USER_PERMISSIONS", userPermissions: permissions });
        };
        getUserPermissions();
        getTimeZones(dispatch);
    }, []);

    React.useEffect(() => {
        if (environmentName) {
            dispatch({ type: "SET_SHOW_NEW_RULE_EDITOR", showNewRuleEditor: false });
            dispatch({ type: "SET_SELECTED_RULE_ID", id: null });
            getRules(dispatch, environmentName);
        }
    }, [environmentName]);

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            <ThemeProvider theme={{ mode: themeType }}>
                {state.environments.length !== 0 &&
                    <>
                        <React.Suspense fallback={<PageLoadSpinner />}>
                            <Layout />
                        </React.Suspense>
                    </>
                }
                {state.isLoading && <PageLoadSpinner />}
            </ThemeProvider>
        </AppContext.Provider>
    );
};

export default App;
